module.exports = __webpack_public_path__ + "img/01020205.7b9df0fa.svg";